import { Injectable, Output, EventEmitter, Component, Input, NgModule, Pipe, defineInjectable } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {MatRadioModule} from '@angular/material/radio';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material/core';
import {MatStepperModule} from '@angular/material/stepper';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatSelectModule} from '@angular/material/select';


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@angular/material/core';
import * as ɵngcc4 from '@angular/material/form-field';
import * as ɵngcc5 from '@angular/material/select';
import * as ɵngcc6 from '@angular/material/input';
import * as ɵngcc7 from '@angular/material/radio';
import * as ɵngcc8 from '@angular/material/datepicker';

function DropdownComponent_mat_option_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 6);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", item_r1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(item_r1);
} }
const _c0 = function (a0) { return { "small-money": a0 }; };
function InputComponent_input_6_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 7);
    ɵngcc0.ɵɵlistener("focus", function InputComponent_input_6_Template_input_focus_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.focusFunction()); })("change", function InputComponent_input_6_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.change($event)); });
    ɵngcc0.ɵɵpipe(1, "currencyFormatter");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disable)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c0, !ctx_r0.showInput))("value", ɵngcc0.ɵɵpipeBind3(1, 3, ctx_r0.data[ctx_r0.model], ctx_r0.useCurrency ? ctx_r0.useCurrency : "", ctx_r0.language));
} }
function InputComponent_input_7_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 8);
    ɵngcc0.ɵɵlistener("focusout", function InputComponent_input_7_Template_input_focusout_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.focusoutFunction()); })("change", function InputComponent_input_7_Template_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r8.change($event)); })("ngModelChange", function InputComponent_input_7_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView((ctx_r9.data[ctx_r9.model] = $event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r1.disable)("id", ctx_r1.model)("type", ctx_r1.type)("ngModel", ctx_r1.data[ctx_r1.model])("placeholder", !ctx_r1.currencyInput ? ctx_r1.placeholder : "");
} }
function InputComponent_textarea_8_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "textarea", 9);
    ɵngcc0.ɵɵlistener("ngModelChange", function InputComponent_textarea_8_Template_textarea_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView((ctx_r10.data[ctx_r10.model] = $event)); })("change", function InputComponent_textarea_8_Template_textarea_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.change($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r2.data[ctx_r2.model])("disabled", ctx_r2.disable)("placeholder", ctx_r2.placeholder);
} }
const _c1 = function (a0) { return { "doubleheight": a0 }; };
const _c2 = function (a0) { return { "textarea-add": a0 }; };
function RadioComponent_mat_radio_group_5_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-radio-group", 5);
    ɵngcc0.ɵɵlistener("change", function RadioComponent_mat_radio_group_5_Template_mat_radio_group_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.change($event)); })("ngModelChange", function RadioComponent_mat_radio_group_5_Template_mat_radio_group_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView((ctx_r5.data[ctx_r5.model] = $event)); });
    ɵngcc0.ɵɵelementStart(1, "mat-radio-button", 6)(2, "p", 7);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd()();
    ɵngcc0.ɵɵelement(4, "br");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.data[ctx_r0.model])("disabled", ctx_r0.disable);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("value", item_r1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1);
} }
class PwoFormsService {
    constructor() {
        this.percCompHolder = [];
        this.percCompCalc = [];
        this.percentageUpdate = new EventEmitter();
    }
    /**
     * @param {?} group
     * @param {?} model
     * @param {?} data
     * @return {?}
     */
    setup(group, model, data) {
        if (!this.percCompHolder.hasOwnProperty(group)) {
            this.percCompHolder[group] = [];
        }
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.percCompHolder[group].push(model);
            this.calculatePercentagePerGroup(data);
        }), 10);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    calculatePercentagePerGroup(data) {
        for (const key in this.percCompHolder) {
            if (this.percCompHolder.hasOwnProperty(key)) {
                /** @type {?} */
                const missing = [];
                /** @type {?} */
                const comp = [];
                for (const item of this.percCompHolder[key]) {
                    if (data[item] && data[item] !== '' && (!Array.isArray(data[item]) || (Array.isArray(data[item]) && data[item].length > 0))) {
                        comp.push(item);
                    }
                    else {
                        missing.push(item);
                    }
                }
                this.percCompCalc[key] = {};
                this.percCompCalc[key].complete = comp.length;
                this.percCompCalc[key].incomplete = missing.length;
                this.percCompCalc[key].total = comp.length + missing.length;
                this.percCompCalc[key].percent = Math.round((comp.length / (comp.length + missing.length)) * 100);
                this.percCompCalc[key].missing = missing;
                this.percCompCalc[key].completed = comp;
            }
        }
        this.percentageUpdate.emit(this.percCompCalc);
    }
    /**
     * @param {?} data
     * @return {?}
     */
    updatePercentage(data) {
        setTimeout((/**
         * @return {?}
         */
        () => { this.calculatePercentagePerGroup(data); }), 10);
    }
    /**
     * @param {?} group
     * @param {?} model
     * @param {?} data
     * @return {?}
     */
    removeModel(group, model, data) {
        if (this.percCompHolder[group]) {
            /** @type {?} */
            const index = this.percCompHolder[group].indexOf(model);
            this.percCompHolder[group].splice(index, 1);
            if (data[model]) {
                data[model] = '';
            }
        }
        this.calculatePercentagePerGroup(data);
    }
}
PwoFormsService.ɵfac = function PwoFormsService_Factory(t) { return new (t || PwoFormsService)(); };
PwoFormsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PwoFormsService, factory: PwoFormsService.ɵfac, providedIn: 'root' });
/** @nocollapse */
PwoFormsService.ctorParameters = () => [];
PwoFormsService.propDecorators = {
    percentageUpdate: [{ type: Output }]
};
/** @nocollapse */ PwoFormsService.ngInjectableDef = defineInjectable({ factory: function PwoFormsService_Factory() { return new PwoFormsService(); }, token: PwoFormsService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFormsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, { percentageUpdate: [{
            type: Output
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DropdownComponent {
    /**
     * @param {?} percentComp
     */
    constructor(percentComp) {
        this.percentComp = percentComp;
        this.placeholder = 'Please enter';
        this.disable = false;
        this.title = '';
        this.progressGroup = 'all';
        this.multiple = false;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.percentComp.removeModel(this.progressGroup, this.model, this.data);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.percentComp.setup(this.progressGroup, this.model, this.data);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    change(e) {
        this.percentComp.updatePercentage(this.data);
    }
}
DropdownComponent.ɵfac = function DropdownComponent_Factory(t) { return new (t || DropdownComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFormsService)); };
DropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DropdownComponent, selectors: [["pwo-forms-dropdown"]], inputs: { placeholder: "placeholder", disable: "disable", title: "title", progressGroup: "progressGroup", multiple: "multiple", items: "items", data: "data", model: "model" }, decls: 7, vars: 7, consts: [[1, "pwo-forms", "step-content-box-item"], [1, "contentbox"], [2, "min-height", "50px", "margin", "0px"], [3, "floatLabel"], [1, "boxed", 3, "multiple", "ngModel", "placeholder", "disabled", "selectionChange", "ngModelChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"]], template: function DropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h4", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "mat-form-field", 3)(5, "mat-select", 4);
        ɵngcc0.ɵɵlistener("selectionChange", function DropdownComponent_Template_mat_select_selectionChange_5_listener($event) { return ctx.change($event); })("ngModelChange", function DropdownComponent_Template_mat_select_ngModelChange_5_listener($event) { return (ctx.data[ctx.model] = $event); });
        ɵngcc0.ɵɵtemplate(6, DropdownComponent_mat_option_6_Template, 2, 2, "mat-option", 5);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("floatLabel", "never");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("multiple", ctx.multiple)("ngModel", ctx.data[ctx.model])("placeholder", ctx.placeholder)("disabled", ctx.disable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc2.NgForOf, ɵngcc3.MatOption, ɵngcc4.MatFormField, ɵngcc5.MatSelect] });
/** @nocollapse */
DropdownComponent.ctorParameters = () => [
    { type: PwoFormsService }
];
DropdownComponent.propDecorators = {
    items: [{ type: Input }],
    data: [{ type: Input }],
    model: [{ type: Input }],
    placeholder: [{ type: Input }],
    disable: [{ type: Input }],
    title: [{ type: Input }],
    progressGroup: [{ type: Input }],
    multiple: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DropdownComponent, [{
        type: Component,
        args: [{ selector: 'pwo-forms-dropdown', template: "<div class=\"pwo-forms step-content-box-item\">\n  <div class=\"contentbox\">\n    <h4 style=\"min-height: 50px; margin: 0px;\">{{title}}</h4>\n    <mat-form-field [floatLabel]=\"'never'\">\n      <mat-select (selectionChange)=\"change($event)\" [multiple]=\"multiple\" [(ngModel)]=\"data[model]\" class=\"boxed\" [placeholder]=\"placeholder\" [disabled]='disable'>\n        <mat-option [value]=\"item\" *ngFor=\"let item of items\">{{item}}</mat-option>\n      </mat-select>\n    </mat-form-field>\n  </div>\n</div>\n\n\n" }]
    }], function () { return [{ type: PwoFormsService }]; }, { placeholder: [{
            type: Input
        }], disable: [{
            type: Input
        }], title: [{
            type: Input
        }], progressGroup: [{
            type: Input
        }], multiple: [{
            type: Input
        }], items: [{
            type: Input
        }], data: [{
            type: Input
        }], model: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class InputComponent {
    /**
     * @param {?} percentComp
     */
    constructor(percentComp) {
        this.percentComp = percentComp;
        this.title = '';
        this.textarea = false;
        this.disable = false;
        this.placeholder = 'Please Enter';
        this.type = 'text';
        this.currencyInput = false;
        this.useCurrency = 'EUR';
        this.progressGroup = 'all';
        this.language = 'en';
        this.showInput = true;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.percentComp.removeModel(this.progressGroup, this.model, this.data);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.percentComp.setup(this.progressGroup, this.model, this.data);
    }
    /**
     * @return {?}
     */
    focusFunction() {
        if (this.currencyInput) {
            this.showInput = false;
            setTimeout((/**
             * @return {?}
             */
            () => {
                document.getElementById(this.model).focus();
            }), 300);
        }
    }
    /**
     * @return {?}
     */
    focusoutFunction() {
        if (this.currencyInput) {
            this.showInput = true;
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    change(e) {
        this.percentComp.updatePercentage(this.data);
    }
}
InputComponent.ɵfac = function InputComponent_Factory(t) { return new (t || InputComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFormsService)); };
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["pwo-forms-input"]], inputs: { title: "title", textarea: "textarea", disable: "disable", placeholder: "placeholder", type: "type", currencyInput: "currencyInput", useCurrency: "useCurrency", progressGroup: "progressGroup", language: "language", model: "model", data: "data" }, decls: 9, vars: 11, consts: [[1, "pwo-forms", "step-content-box-item"], [1, "contentbox", 2, "position", "relative", 3, "ngClass"], [2, "min-height", "50px", "margin", "0px"], [1, "forms-input", 3, "floatLabel", "ngClass"], ["matInput", "", 3, "disabled", "ngClass", "value", "focus", "change", 4, "ngIf"], ["matInput", "", 3, "disabled", "id", "type", "ngModel", "placeholder", "focusout", "change", "ngModelChange", 4, "ngIf"], ["matInput", "", "class", "textarea-input", 3, "ngModel", "disabled", "placeholder", "ngModelChange", "change", 4, "ngIf"], ["matInput", "", 3, "disabled", "ngClass", "value", "focus", "change"], ["matInput", "", 3, "disabled", "id", "type", "ngModel", "placeholder", "focusout", "change", "ngModelChange"], ["matInput", "", 1, "textarea-input", 3, "ngModel", "disabled", "placeholder", "ngModelChange", "change"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h4", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div")(5, "mat-form-field", 3);
        ɵngcc0.ɵɵtemplate(6, InputComponent_input_6_Template, 2, 9, "input", 4);
        ɵngcc0.ɵɵtemplate(7, InputComponent_input_7_Template, 1, 5, "input", 5);
        ɵngcc0.ɵɵtemplate(8, InputComponent_textarea_8_Template, 1, 3, "textarea", 6);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c1, ctx.textarea));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("floatLabel", "never")("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c2, ctx.textarea));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.currencyInput);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.showInput && ctx.currencyInput && !ctx.textarea || !ctx.currencyInput && !ctx.textarea);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.textarea);
    } }, dependencies: function () { return [ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc2.NgClass, ɵngcc2.NgIf, ɵngcc4.MatFormField, ɵngcc6.MatInput, CurrencyFormatterPipe]; }, styles: [".doubleheight[_ngcontent-%COMP%]{height:160px!important}.textarea-input[_ngcontent-%COMP%]{height:80px;max-height:80px;min-height:80px}.small-money[_ngcontent-%COMP%]{position:absolute;top:-7px;font-size:10px}input[_ngcontent-%COMP%]{transition:.3s ease-in-out}"] });
/** @nocollapse */
InputComponent.ctorParameters = () => [
    { type: PwoFormsService }
];
InputComponent.propDecorators = {
    title: [{ type: Input }],
    textarea: [{ type: Input }],
    disable: [{ type: Input }],
    model: [{ type: Input }],
    data: [{ type: Input }],
    placeholder: [{ type: Input }],
    type: [{ type: Input }],
    currencyInput: [{ type: Input }],
    useCurrency: [{ type: Input }],
    progressGroup: [{ type: Input }],
    language: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{ selector: 'pwo-forms-input', template: "\n\n<div class=\"pwo-forms step-content-box-item\">\n    <div class=\"contentbox\" [ngClass]=\"{'doubleheight': textarea}\" style=\"position: relative\">\n    <h4 style=\"min-height: 50px; margin: 0px;\">{{title}}</h4>\n\n    <div>\n      <mat-form-field class=\"forms-input\" [floatLabel]=\"'never'\" [ngClass]=\"{'textarea-add': textarea}\">\n        <input (focus)=\"focusFunction()\" [disabled]='disable' (change)=\"change($event)\" [ngClass]=\"{'small-money': !showInput}\" *ngIf=\"currencyInput\" [value]=\"data[model] | currencyFormatter: (useCurrency ? useCurrency : '') : language\" matInput>\n        <input (focusout)=\"focusoutFunction()\" [disabled]='disable' [id]=\"model\" *ngIf=\"(!showInput && currencyInput && !textarea) || (!currencyInput && !textarea)\" [type]=\"type\" (change)=\"change($event)\" [(ngModel)]=\"data[model]\" matInput [placeholder]=\"!currencyInput ? (placeholder) : ''\">\n        <textarea matInput *ngIf=\"textarea\" [(ngModel)]=\"data[model]\" [disabled]='disable' [placeholder]=\"placeholder\" class=\"textarea-input\" (change)=\"change($event)\"></textarea>\n      </mat-form-field>\n    </div>\n\n  </div>\n</div>\n\n", styles: [".doubleheight{height:160px!important}.textarea-input{height:80px;max-height:80px;min-height:80px}.small-money{position:absolute;top:-7px;font-size:10px}input{transition:.3s ease-in-out}"] }]
    }], function () { return [{ type: PwoFormsService }]; }, { title: [{
            type: Input
        }], textarea: [{
            type: Input
        }], disable: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], type: [{
            type: Input
        }], currencyInput: [{
            type: Input
        }], useCurrency: [{
            type: Input
        }], progressGroup: [{
            type: Input
        }], language: [{
            type: Input
        }], model: [{
            type: Input
        }], data: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CurrencyFormatterPipe {
    constructor() { }
    /**
     * @param {?} value
     * @param {?} currencySymbol
     * @param {?} lang
     * @param {?=} before
     * @return {?}
     */
    transform(value, currencySymbol, lang, before) {
        return this.FormatCurrency(value, currencySymbol, lang, before);
    }
    /**
     * @param {?} input
     * @param {?=} currencySymbol
     * @param {?=} lang
     * @param {?=} before
     * @return {?}
     */
    FormatCurrency(input, currencySymbol = '', lang = 'en', before = true) {
        /** @type {?} */
        const isNegative = input < 0;
        input = Math.abs(input);
        /** @type {?} */
        const currencySymbolFormatted = currencySymbol;
        /** @type {?} */
        const placement = before === undefined ? true : before;
        /** @type {?} */
        let formattedInput;
        if (isNaN(input)) {
            formattedInput = this._formatBigNumbers(0, 2, lang);
            // formattedInput = '-';
        }
        else {
            formattedInput = this._formatBigNumbers(input, 2, lang);
        }
        if (placement === true) {
            return currencySymbolFormatted + ' ' + (isNegative ? '-' : '') + formattedInput;
        }
        else {
            return (isNegative ? '-' : '') + formattedInput + ' ' + currencySymbolFormatted;
        }
    }
    /**
     * @private
     * @param {?} input
     * @param {?} decimals
     * @param {?} lang
     * @return {?}
     */
    _formatBigNumbers(input, decimals, lang) {
        /** @type {?} */
        let decSep = '.';
        /** @type {?} */
        let thousandSep = ',';
        if (lang === 'de') {
            decSep = ',';
            thousandSep = '.';
        }
        if (input !== undefined) {
            /** @type {?} */
            const inputString = input.toString();
            if (inputString.split('.')[0].length > 6) {
                // tslint:disable-next-line:no-bitwise
                /** @type {?} */
                const millions = input / 1000000 >> 0;
                // tslint:disable-next-line:no-bitwise
                /** @type {?} */
                let remainder = (input % 1000000) / 1000 >> 0;
                if (remainder > 1000) {
                    remainder = Math.round(remainder);
                }
                return this._formatNumber(millions, 0, null, decSep, thousandSep) + '\'' + this._pad(remainder);
            }
            else {
                return this._formatNumber(input, decimals, null, decSep, thousandSep);
            }
        }
        else {
            return this._formatNumber(input, decimals, null, decSep, thousandSep);
        }
    }
    /**
     * @private
     * @param {?} input
     * @param {?} decimals
     * @param {?=} wholeLength
     * @param {?=} decimalSep
     * @param {?=} thousandSep
     * @return {?}
     */
    _formatNumber(input, decimals, wholeLength = null, decimalSep = '.', thousandSep = ',') {
        /** @type {?} */
        const re = '\\d(?=(\\d{' + (wholeLength || 3) + '})+' + (decimals > 0 ? '\\D' : '$') + ')';
        /** @type {?} */
        let num = '';
        input = parseFloat(input + '');
        // tslint:disable-next-line:no-bitwise
        if (input !== undefined) {
            num = input.toFixed(Math.max(0, ~~decimals));
        }
        return (decimalSep ? num.replace('.', decimalSep) : num).replace(new RegExp(re, 'g'), '$&' + (thousandSep || ','));
    }
    /**
     * @private
     * @param {?} num
     * @param {?=} size
     * @return {?}
     */
    _pad(num, size = 3) {
        if (num !== undefined) {
            /** @type {?} */
            let s = num + '';
            while (s.length < size) {
                s = '0' + s;
            }
            return s;
        }
        else {
            return num + '';
        }
    }
}
CurrencyFormatterPipe.ɵfac = function CurrencyFormatterPipe_Factory(t) { return new (t || CurrencyFormatterPipe)(); };
CurrencyFormatterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "currencyFormatter", type: CurrencyFormatterPipe, pure: true });
/** @nocollapse */
CurrencyFormatterPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CurrencyFormatterPipe, [{
        type: Pipe,
        args: [{
                name: 'currencyFormatter'
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class RadioComponent {
    /**
     * @param {?} percentComp
     */
    constructor(percentComp) {
        this.percentComp = percentComp;
        this.title = '';
        this.items = [];
        this.progressGroup = 'all';
        this.disable = false;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.percentComp.removeModel(this.progressGroup, this.model, this.data);
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.percentComp.setup(this.progressGroup, this.model, this.data);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    change(e) {
        this.percentComp.updatePercentage(this.data);
    }
}
RadioComponent.ɵfac = function RadioComponent_Factory(t) { return new (t || RadioComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFormsService)); };
RadioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["pwo-forms-radio"]], inputs: { title: "title", items: "items", progressGroup: "progressGroup", disable: "disable", data: "data", model: "model" }, decls: 6, vars: 2, consts: [[1, "pwo-forms", "step-content-box-item"], [1, "contentbox", 2, "height", "auto", "margin-bottom", "30px"], [2, "margin", "0px"], [2, "margin-top", "10px"], [3, "ngModel", "disabled", "change", "ngModelChange", 4, "ngFor", "ngForOf"], [3, "ngModel", "disabled", "change", "ngModelChange"], [3, "value"], [2, "margin-top", "10px", "margin-bottom", "10px", "font-size", "108%"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h4", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3);
        ɵngcc0.ɵɵtemplate(5, RadioComponent_mat_radio_group_5_Template, 5, 4, "mat-radio-group", 4);
        ɵngcc0.ɵɵelementEnd()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.items);
    } }, dependencies: [ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc2.NgForOf, ɵngcc7.MatRadioGroup, ɵngcc7.MatRadioButton] });
/** @nocollapse */
RadioComponent.ctorParameters = () => [
    { type: PwoFormsService }
];
RadioComponent.propDecorators = {
    title: [{ type: Input }],
    items: [{ type: Input }],
    data: [{ type: Input }],
    model: [{ type: Input }],
    progressGroup: [{ type: Input }],
    disable: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{ selector: 'pwo-forms-radio', template: "<div class=\"pwo-forms step-content-box-item\">\n  <div class=\"contentbox\" style=\"height: auto; margin-bottom: 30px;\">\n    <h4 style=\"margin: 0px;\">{{title}}</h4>\n    <div  style=\"margin-top:10px;\">\n        <mat-radio-group (change)=\"change($event)\" *ngFor=\"let item of items; let i = index\" [(ngModel)]=\"data[model]\" [disabled]='disable'>\n            <mat-radio-button value=\"{{item}}\"><p style=\"margin-top: 10px; margin-bottom:10px;font-size: 108%\">{{ item }}</p></mat-radio-button><br>\n        </mat-radio-group>\n    </div>\n  </div>\n</div>\n\n" }]
    }], function () { return [{ type: PwoFormsService }]; }, { title: [{
            type: Input
        }], items: [{
            type: Input
        }], progressGroup: [{
            type: Input
        }], disable: [{
            type: Input
        }], data: [{
            type: Input
        }], model: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const MY_FORMATS = {
    parse: {
        dateInput: 'DD.MM.YYYY',
    },
    display: {
        dateInput: 'DD.MM.YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
class DateComponent {
    /**
     * @param {?} percentComp
     */
    constructor(percentComp) {
        this.percentComp = percentComp;
        this.title = '';
        this.progressGroup = 'all';
        this.disable = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.percentComp.setup(this.progressGroup, this.model, this.data);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.percentComp.removeModel(this.progressGroup, this.model, this.data);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    change(e) {
        this.percentComp.updatePercentage(this.data);
    }
}
DateComponent.ɵfac = function DateComponent_Factory(t) { return new (t || DateComponent)(ɵngcc0.ɵɵdirectiveInject(PwoFormsService)); };
DateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DateComponent, selectors: [["pwo-forms-date"]], inputs: { title: "title", progressGroup: "progressGroup", disable: "disable", data: "data", model: "model" }, features: [ɵngcc0.ɵɵProvidersFeature([
            { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
            { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        ])], decls: 10, vars: 5, consts: [[1, "pwo-forms", "step-content-box-item"], [1, "contentbox"], [2, "min-height", "50px", "margin", "0px"], [2, "padding-top", "5px"], ["matInput", "", "placeholder", "Date", 3, "ngModel", "matDatepicker", "disabled", "ngModelChange"], ["matSuffix", "", 3, "for"], ["picker", ""]], template: function DateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h4", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 3)(5, "mat-form-field")(6, "input", 4);
        ɵngcc0.ɵɵlistener("ngModelChange", function DateComponent_Template_input_ngModelChange_6_listener($event) { return ctx.change($event); })("ngModelChange", function DateComponent_Template_input_ngModelChange_6_listener($event) { return (ctx.data[ctx.model] = $event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "mat-datepicker-toggle", 5)(8, "mat-datepicker", null, 6);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(9);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.title);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngModel", ctx.data[ctx.model])("matDatepicker", _r0)("disabled", ctx.disable);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("for", _r0);
    } }, dependencies: [ɵngcc1.DefaultValueAccessor, ɵngcc1.NgControlStatus, ɵngcc1.NgModel, ɵngcc4.MatFormField, ɵngcc4.MatSuffix, ɵngcc6.MatInput, ɵngcc8.MatDatepicker, ɵngcc8.MatDatepickerInput, ɵngcc8.MatDatepickerToggle] });
/** @nocollapse */
DateComponent.ctorParameters = () => [
    { type: PwoFormsService }
];
DateComponent.propDecorators = {
    title: [{ type: Input }],
    data: [{ type: Input }],
    model: [{ type: Input }],
    progressGroup: [{ type: Input }],
    disable: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateComponent, [{
        type: Component,
        args: [{ selector: 'pwo-forms-date', template: "<div class=\"pwo-forms step-content-box-item\">\n  <div class=\"contentbox\">\n      <h4 style=\"min-height: 50px; margin: 0px;\">{{title}}</h4>\n      <div style=\"padding-top: 5px;\">\n        <mat-form-field>\n          <input (ngModelChange)=\"change($event)\" [(ngModel)]=\"data[model]\" matInput [matDatepicker]=\"picker\" placeholder=\"Date\" [disabled]='disable'/>\n          <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle>\n          <mat-datepicker #picker></mat-datepicker>\n        </mat-form-field>\n      </div>\n    </div>\n</div>\n", providers: [
                    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
                ] }]
    }], function () { return [{ type: PwoFormsService }]; }, { title: [{
            type: Input
        }], progressGroup: [{
            type: Input
        }], disable: [{
            type: Input
        }], data: [{
            type: Input
        }], model: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PwoFormsModule {
}
PwoFormsModule.ɵfac = function PwoFormsModule_Factory(t) { return new (t || PwoFormsModule)(); };
PwoFormsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: PwoFormsModule });
PwoFormsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [FormsModule,
        CommonModule,
        MatAutocompleteModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatStepperModule,
        MatIconModule,
        MatCardModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PwoFormsModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    DropdownComponent,
                    InputComponent,
                    CurrencyFormatterPipe,
                    RadioComponent,
                    DateComponent,
                ],
                imports: [
                    FormsModule,
                    CommonModule,
                    MatAutocompleteModule,
                    MatInputModule,
                    MatCheckboxModule,
                    MatRadioModule,
                    MatSelectModule,
                    MatDatepickerModule,
                    MatNativeDateModule,
                    MatStepperModule,
                    MatIconModule,
                    MatCardModule
                ],
                exports: [
                    DropdownComponent,
                    InputComponent,
                    CurrencyFormatterPipe,
                    RadioComponent,
                    DateComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(PwoFormsModule, { declarations: function () { return [DropdownComponent, InputComponent, CurrencyFormatterPipe, RadioComponent, DateComponent]; }, imports: function () { return [FormsModule,
        CommonModule,
        MatAutocompleteModule,
        MatInputModule,
        MatCheckboxModule,
        MatRadioModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatStepperModule,
        MatIconModule,
        MatCardModule]; }, exports: function () { return [DropdownComponent, InputComponent, CurrencyFormatterPipe, RadioComponent, DateComponent]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { PwoFormsService, PwoFormsModule, CurrencyFormatterPipe, DateComponent as ɵe, MY_FORMATS as ɵd, DropdownComponent as ɵa, InputComponent as ɵb, RadioComponent as ɵc };


